// TextEditor.tsx
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    // [
    //   { list: 'ordered' },
    //   { list: 'bullet' },
    //   { indent: '-1' },
    //   { indent: '+1' },
    // ],
    // ['link', 'code'],
    // ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'code',
];

interface OnChangeHandler {
  (e: any): void;
}

type Props = {
  value?: string;
  placeholder?: string;
  onChange?: OnChangeHandler;
  readonly?: boolean;
};

export const TextEditor: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  readonly = false
}) => {
  return (
    <ReactQuill
      theme="snow"
      readOnly={readonly}
      value={value || ''}
      modules={readonly ? { toolbar: [] } : modules}
      formats={formats}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};
